module.exports = __webpack_public_path__ + "static/media/gift-card.855b316c.gif";